import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import {
    TableContentWithoutEdit
} from "../../../Common/Table/tableContent";
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { FactoryRouteWeighReportSchemaObject } from "../factoryRouteWeighReportSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import xlsx from 'json-as-xlsx';
import _ from 'lodash';
import {
    TableContentForFactoryRouteWeighReport,
    TableContentForSumLeafCollectionVarianceReport
} from "../../../Common/Table/tableContent";
import { useExcelDownloder } from 'react-xls';
import ReactExport from "react-export-excel";
import Chip from '@material-ui/core/Chip';
import LineWeightIcon from '@material-ui/icons/LineWeight';
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import divisionService from '../../../Devision/services';
import { LoadingMaterialTable } from "../../../../Common/table";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const screenCode = "SUBORDINATECOLLECTIONREPORT";

export function SubordinateCollectionReport(props) {

    const componentRef = useRef();
    const [reportData, setReportData] = useState([]);
    const [groups, setGroups] = useState([]);
    const [factories, setFactories] = useState([]);
    const [routes, setRoutes] = useState([]);

    const [estates, setEstates] = useState();
    const [divisions, setDivisions] = useState();

    const [isTableHide, setIsTableHide] = useState(true);

    const [leafCollectionVariance, setLeafCollectionDetails] = useState({
        groupID: "0",
        factoryID: "0",
        routeID: "0",
        estateID: "0",
        divisionID: "0",
        date: ""
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "",
        estate: "",
        division: "",
        date: ""
    });

    const [errors, setErrors] = useState({});

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const schema = Joi.object(FactoryRouteWeighReportSchemaObject).options({ allowUnknown: true });



    const [contentRowNames, setContentRowNames] = useState(["employeeName", "registrationNumber", "subordianCode", "subordianName", "actualAmount", "grossAmount", "netAmount","totalDeduction","totalAmount"]);

    const initialCsvHeaders = [
        { label: "Employee Name", value: "employeeName" },
        { label: "Registration Number", value: "registrationNumber" },
        { label: "Subordian Code", value: "subordianCode" },
        { label: "Subordian Name", value: "subordianName" },
        { label: "Actual Amount", value: "actualAmount" },
        { label: "Gross sAmount", value: "grossAmount" },
        { label: "Net Amount", value: "netAmount" },
        { label: "Total Deduction", value: "totalDeduction" },
        { label: "Total Amount", value: "totalAmount" }
        
    ]
    const [csvHeaders, setCsvHeaders] = useState(initialCsvHeaders);
    const [csvData, setCsvData] = useState([]);
    const { ExcelDownloder, Type, e } = useExcelDownloder();
    const [totalNet, setTotalNet] = useState({
        total:0,
        netTotal : 0,
        actualTotal : 0,
        grossTotal : 0,
        totalAmount : 0
    }); 
    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getEsatesForDropDown(),
        )
    }, [leafCollectionVariance.groupID])

    useEffect(() => {
        trackPromise(
            GetDivisionForDropDown()
        )
    }, [leafCollectionVariance.estateID])


    async function getEsatesForDropDown() {
        const factoryList = await divisionService.getEstatesByGroupID(leafCollectionVariance.groupID);
        setEstates(factoryList);
    }

    async function GetDivisionForDropDown() {
        const routeList = await services.GetDivisionByEstateID(leafCollectionVariance.estateID);
        setDivisions(routeList);
    }

    function handleGroupChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionVariance,
            groupID: target.value,
            factoryID: "0",
            routeID: "0"

        });
        setIsTableHide(true);
    }

    function handleFactoryChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionVariance,
            estateID: target.value,
            routeID: "0"
        });
        setIsTableHide(true);
    }

    function handleRouteChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionVariance,
            divisionID: target.value,
        });
        setIsTableHide(true);
    }

    function handleFromDateChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionVariance,
            date: target.value,
        });
        setIsTableHide(true);
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, FactoryRouteWeighReportSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWSUBORDINATEREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');


        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromToken();

        setLeafCollectionDetails({
            ...leafCollectionVariance,
            groupID: token.groupID,
            factoryID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }


    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getFactoriesForDropdown() {
        const data = await services.getFactoriesByGroupID(leafCollectionVariance.groupID);
        setFactories(data);
    }

    async function getRoutesForDropDown() {
        const data = await services.getAllRoutesByFactoryID(leafCollectionVariance.factoryID);
        setRoutes(data);
    }


    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }


    async function handleSearch(e) {
        e.preventDefault();
        setIsTableHide(false);

        const errorMessages = validate(schema, leafCollectionVariance);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;
        var res = await services.getSubordianReportData(leafCollectionVariance);
        var total = 0;
        var netTotal = 0;
        var actualTotal = 0;
        var grossTotal = 0;
        var totalAmountx = 0;

        res.forEach(x => {
            x.pluckingCollectionID = x.pluckingCollectionID;
            x.employeeID= x.employeeID;
            x.registrationNumber= x.registrationNumber;
            x.employeeName= x.employeeName;
            x.subordianCode= x.subordianCode;
            x.subordianName= x.subordianName;
            x.actualAmount= x.actualAmount;
            x.grossAmount= x.grossAmount;
            x.netAmount= x.netAmount;
            x.totalDeduction= x.totalDeduction;
            x.totalAmount = x.totalAmount;

            total += x.totalDeduction;
            netTotal += x.netAmount;
            actualTotal += x.actualAmount;
            grossTotal += x.grossAmount;
            totalAmountx += x.totalAmount;
        })
       
        setTotalNet({
            total:total,
            netTotal:netTotal,
            actualTotal:actualTotal,
            grossTotal:grossTotal,
            totalAmount:totalAmountx
        })
        if (res != null || res.length != 0) {
            setReportData(res);
            setCsvData(res);
            getSelectedDropdownValuesForReport(leafCollectionVariance)
        }


    }

    function generateCsvData(data, totalRowResult, contentResult) {

        var copyOfData = _.cloneDeep(data);
        var newRecord = { filedDate: "Total" }

        newRecord.fieldNumberOfUnits = totalRowResult.bagCount;
        totalRowResult.forEach(x => {
            newRecord[x.name] = x.value === undefined ? (0).toFixed(2) : x.value.toFixed(2);
        });

        copyOfData.push(newRecord);
        setCsvData(copyOfData);
    }





    function createFile() {
        var settings = {
            sheetName: ( "Sub-Weighment-Report" + ' ' + leafCollectionVariance.date ),
            fileName: ( "Sub-Weighment-Report" + ' ' + leafCollectionVariance.date ),
            writeOptions: {}
        }

        xlsx(csvHeaders, csvData, settings, true)
    }

    function onCancelClick() {
        clearState();
    }

    function clearState() {
        setLeafCollectionDetails({
            ...leafCollectionVariance,
            routeID: "0",
            date: ""
        });
        setIsTableHide(true);
        setErrors("");
    }


    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[leafCollectionVariance.groupID],
            estate: estates[leafCollectionVariance.estateID],
            division: divisions[leafCollectionVariance.divisionID],
            date: leafCollectionVariance.date
        })
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title="Subordinates Weighment Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={leafCollectionVariance.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="factoryID">Estate *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="estateID"
                                            id="estateID"
                                            name="estateID"
                                            value={leafCollectionVariance.estateID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleFactoryChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Estate--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["estateID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">Division *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="divisionID"
                                            id="divisionID"
                                            name="divisionID"
                                            value={leafCollectionVariance.divisionID}
                                            onChange={(e) => handleRouteChange(e.target)}
                                        >
                                           <MenuItem value="0">--All Division--</MenuItem>
                                            {generateDropDownMenu(divisions)}
                                        </Select>
                                        {errors["divisionID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["divisionID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="searchDate">Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="date"
                                            name="date"
                                            type="date"
                                            onChange={(e) => handleFromDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                    </div>
                                </div>

                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, leafCollectionVariance)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />

                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Cancel"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>

                            {isTableHide ? null :
                                <div>
                                    <br />
                                    <Chip
                                        icon={<LineWeightIcon />}
                                        label={"Total Actual : " + totalNet.actualTotal}
                                        color="secondary"
                                        variant="outlined"
                                    />&nbsp;
                                     <Chip
                                        icon={<LineWeightIcon />}
                                        label={"Total Gross : " + totalNet.grossTotal}
                                        color="secondary"
                                        variant="outlined"
                                    /> &nbsp;
                                     <Chip
                                        icon={<LineWeightIcon />}
                                        label={"Total Net : " + totalNet.netTotal}
                                        color="secondary"
                                        variant="outlined"
                                    />&nbsp;
                                    <Chip
                                        icon={<LineWeightIcon />}
                                        label={"Total Deduction : " + totalNet.total}
                                        color="secondary"
                                        variant="outlined"
                                    />
                                    &nbsp;
                                    <Chip
                                        icon={<LineWeightIcon />}
                                        label={"Total Checkroll : " + totalNet.totalAmount}
                                        color="secondary"
                                        variant="outlined"
                                    />
                                    <br />
                                    <br />


                                    <LoadingMaterialTable
                                        title=""
                                        columns={[
                                            { title: "Employee Name", field: "employeeName" },
                                            { title: "Registration Number", field: "registrationNumber" },
                                            { title: "Subordian Code", field: "subordianCode" },
                                            { title: "Subordian Name", field: "subordianName" },
                                            { title: "Actual Amount", field: "actualAmount" },
                                            { title: "Gross Amount", field: "grossAmount" },
                                            { title: "Total Deduction", field: "totalDeduction" },
                                            { title: "Net Amount", field: "netAmount" },
                                            { title: "Checkroll Amount", field: "totalAmount" }
                                        ]}
                                        data={reportData}
                                    />
                                <div className="pt-2">
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />

                                        <ReactToPrint
                                            documentTitle={"Subordinates Weighment Report"}
                                            trigger={() => <input
                                                type="submit"
                                                className="btn btn-primary pull-right ml-2"
                                                value="PDF"

                                            />}
                                            content={() => componentRef.current}
                                        />
                                    </div>

                                    
                                    <div hidden={true}>
                                        <CreatePdf ref={componentRef} data={reportData}
                                            rowNames={contentRowNames} searchData={selectedSearchValues} 
                                             />
                                    </div>
                                </div>
                                
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
